export enum DeliveryOrderCancellationRequestStatus {
    Pending = "Pending",
    Rejected = "Rejected",
    Confirmed = "Confirmed",
}
